export class TmsRole {
    public id: number | null;
    public role_name: string | null;
    public description: string | null;
    public c: number| null;
    public visible_in_wizard: number| null;
    public tms_type: number| null;

    constructor(data: TmsRoleData | undefined | null = undefined) {
        if (data === undefined || data === null) {
            this.id = null;
            this.role_name = "";
            this.description = "";
            this.c = null;
            this.visible_in_wizard = null;
            this.tms_type = null;
        }
        else {
            this.id = data.id;
            this.role_name = data.role_name;
            this.description = data.description;
            this.c = data.c;
            this.visible_in_wizard = data.visible_in_wizard;
            this.tms_type = data.tms_type;
        }
    }

    serializeData():TmsRoleData {
        return {
            id: this.id,
            role_name: this.role_name,
            description: this.description,
            c: this.c,
            visible_in_wizard: this.visible_in_wizard,
            tms_type: this.tms_type,
        }
    }
}

export type TmsRoleData = {
    id: number | null;
    role_name: string| null;
    description: string| null;
    c: number| null;
    visible_in_wizard: number| null;
    tms_type: number| null;
}
